module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1045-fff1489ed401a6027caba4e2006064cb.png";